import { Injectable, RendererFactory2, effect, inject, signal } from '@angular/core';
import { Theme } from '../types/theme.model';

/**
 * Service to manage the theme of the application.
 * This service will be replaced by a more complete service in the future and will be provided by the Design System.
 */
@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly renderer = inject(RendererFactory2).createRenderer(null, null);
  public theme = signal<Theme>('light');

  constructor() {
    effect(() => {
      if (this.theme() === 'dark') {
        this.renderer.addClass(document.body, 'dark');
      } else {
        this.renderer.removeClass(document.body, 'dark');
      }
    });
  }

  public toggleTheme(): void {
    this.theme.update(theme => (theme === 'light' ? 'dark' : 'light'));
  }

  public setTheme(theme: Theme): void {
    this.theme.set(theme);
  }
}
